<template>
	<div id="login" class="pos-fix z-index-1">
        <div class="pos-rel dp-fx fx-js-ct wd-full ht-full">
            <div class="mg-t-60">
            	<div class="text-center">
                	<img height="40" src="../assets/logo.png" alt="Nepometer Logo"/>
            	</div>
                <div class="mg-t-40 login-title-cont login-title pos-rel tx-ct">
                    <span class="login-title_inner dp-ib pos-rel bg-white">
                        <p class="dp-ib vt-align-middle text-login fz-22 lh-26">Login</p>
                    </span>
                </div>
                <div class="wd-full" id="social-login"></div>
                <p class="tx-ct wd-px-300">
                    <span class="fz-12 lh-18">By creating account you agree with our terms and privacy policy.</span>
                </p>
                <p class="tx-ct mg-t-30 wd-full">
                    <span class="fz-16 lh-20 fw-7 cs-ptr pd-t-10 pd-b-10 pd-l-10 pd-r-10" @click="loginDismiss">Not Now</span>
                </p>
            </div>
        </div>
	</div>
</template>

<style>
    .wd-px-300{
        width: 300px;
    }
    .login-title-cont {
        overflow: visible;
    }
    .bg-white{
        background-color: #ffffff;
    }
    .vt-align-middle{
        vertical-align: middle;
    }
    .login-title-cont.login-title:before {
        border-left: 1px solid #e9ebf2;
        border-right: 1px solid #e9ebf2;
        border-top: 1px solid #e9ebf2;
        content: " ";
        height: 30px;
        left: 0;
        position: absolute;
        right: 0;
        top: 50%;
        box-sizing: border-box;
    }

</style>

<script>
    const fb = require('../firebaseConfig.js');
    const fbui = require('firebaseui');
    const loginUi = new fbui.auth.AuthUI(fb.auth());
    
    export default {
        name: 'Login',
        data: function() {
        	return {
        		prevRoute: null
        	}
        },
        mounted: function () {
        	this.setupUI();
        },
        methods: {
        	setupUI: function() {
        		let _trouter = this.$router
			    let uiConfig = {
			        callbacks: {
			            signInSuccessWithAuthResult: function(authResult, redirectUrl) {
			                // User successfully signed in.
			                // Return type determines whether we continue the redirect automatically
			                // or whether we leave that to developer to handle.
			                console.log(authResult, redirectUrl);
			                return true;
			            },
			        },
			        signInFlow: 'popup',
			        signInOptions: [
			            fb.auth.GoogleAuthProvider.PROVIDER_ID,
			            fb.auth.TwitterAuthProvider.PROVIDER_ID,
			        ],
			    };
	        	uiConfig.signInSuccessUrl = '/';
                loginUi.start('#social-login', uiConfig);
                this.$store.dispatch('deactivateCommentsModal');
			},
            loginDismiss: function () {
                this.$router.back();
                this.$store.dispatch('deactivateCommentsModal');
            }
        },
		/*beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.prevRoute = from
			})
		},*/
    };
</script>